import { SearchCompanyItem, SearchResponse } from '@/apiTypes/types';
import { loadSearchData } from '@/lib/dataProviders/search/loadSearchData';
import { SearchV3Scope } from '@/lib/enums/searchScope';

type SearchParams = {
  query?: string;
  scope?: SearchV3Scope;
  onlyRegisteredCompanies?: boolean;
};

type PaginationProps = {
  from: number;
  limit: number;
};

export async function loadSearch(search: SearchParams, pagination: PaginationProps): Promise<{ items: SearchCompanyItem[] }> {
  const response = await loadSearchData<SearchResponse>({
    uri: '/v2/search/infopank',
    params: {
      query: search?.query,
      scope: search?.scope,
      onlyRegisteredCompanies: search?.onlyRegisteredCompanies ? '1' : undefined,
      from: pagination.from.toString(),
      limit: pagination.limit.toString(),
    },
    revalidate: 0,
  });

  return { items: response.companies?.items ?? [] };
}
